export default __webpack_public_path__ + "static/media/avatar-review-5.98b414f0.svg";